export default {
    init() {
        // JavaScript to be fired on the single cases page
    },
    finalize() {
        $('.news-carousel').slick({
            dots: true,
            speed: 500,
            infinite: true,
            slidesToShow: 3,
            draggable: true,
            swipe: true,
            touchMove: true,
            swipeToSlide: true,
            touchThreshold: 6,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    swipe: true,
                    touchMove: true,
                    swipeToSlide: true,
                    touchThreshold: 6,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                    swipe: true,
                    touchMove: true,
                    swipeToSlide: true,
                    touchThreshold: 6,
                },
            }],
        });

        function rebindScroller(){
            $(document).scroll(function(){
                if($(window).scrollTop() >= $(".entry-content-wrapper").offset().top + 75 && $(window).scrollTop() < parseInt($(".entry-container").height(), 10) + 250){
                    $(".social-buttons:not(.mobile)").css({
                        top: 0,
                        left: ($(".entry-content-wrapper").offset().left - 18) + "px",
                        position: "fixed",
                    });
                }else if($(window).scrollTop() >= parseInt($(".entry-container").height(), 10) + 250){
                    $(".social-buttons:not(.mobile)").css({
                        top: ($(".entry-container").height() - 350) + "px",
                        left: "-18px",
                        position: "absolute",
                    });
                }else{
                    $(".social-buttons:not(.mobile)").css({
                        top: 75,
                        left: "-18px",
                        position: "absolute",
                    });
                }
            });
        }
        rebindScroller();

        $(".social-buttons a").click(function(e) {
            e.preventDefault();
            window.open($(this).attr("href"), '_blank', "height=500,width=500,toolbar=0,location=0,menubar=0");
            return false
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-blog.js